import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppUser } from '@/contexts/AppUserProvider';

interface ProtectedRouteProps {
  element: ReactElement;
  requireSuperAdmin?: boolean;
}

export const ProtectedRoute = ({ element, requireSuperAdmin = false }: ProtectedRouteProps) => {
  const { appUser, isLoading } = useAppUser();

  // Show nothing while loading to prevent flashing
  if (isLoading) {
    return null;
  }

  // If super admin is required and user is not a super admin, redirect to create page
  if (requireSuperAdmin && !appUser?.isSuperAdmin) {
    return <Navigate to="/create" replace />;
  }

  return element;
};



